import { useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL } from "../../../config";
import { getIndependentSymbol, getTimeAgo, translate, translateNumber } from "../../../helper";
import NotFound from "../../common/ErrorPage/NotFound";
import { Loader } from "../../common/Loader";
import LangContext from "../../../contexts/LangContext";

import "./index.css";

const Profile = (props) => {
  const { lang } = useContext(LangContext);
  const { cid } = useParams();
  if (!cid) {
    return <NotFound />;
  }
  const candidate = props.data.find((c) => c.id === parseInt(cid));

  if (!props.fetched) {
    return <Loader />;
  }

  if (!candidate) {
    return <NotFound />;
  }

  const timeAgo = getTimeAgo(candidate.updated_at);
  const candidatePartyCode = candidate.party_code.match(/I+\d/) ? "I" : candidate.party_code;
  const candidateGender = candidate.gender ? candidate.gender : "O";
  const candidatePhotoSrc =
    candidate.candidatephoto && candidate.candidatephoto.trim() !== ""
      ? candidate.candidatephoto
      : `https://result.election.gov.np/Images/Candidate/${candidate.candidateid}.jpg`;

  let symbol = candidatePartyCode;
  if (symbol === "I") {
    symbol = getIndependentSymbol(candidate.district_id, candidate.region_id, candidate.name_en);
  }

  // console.log(candidate, 'candidate_details')

  return (
    <div className="sh-candidate-profile-page">
      <div className="container mb-4">
        <div className="sh-profile-layout">
          <div className="sh-profile-main">
            <div className="sh-profile-card">
              <div className="sh-profile-card-head">
                <h2>{translate("candidate_profile", lang)}</h2>
                <div className="sh-profile-vote">
                 
                </div>
                <div class="sh-banner-winner-section">
                                {candidate.elected  && <span className="sh-banner-winner sh-banner-winner-candidate">{ <img src={ "https://assets.deshsanchar.com/wp-content/uploads/2026/02/25194001/checklist2.png"} alt="winner" width="20px" height="20px" />}<span>{translate("elected", lang)}</span></span>}
                                {/* {candidate.vote > 0 && !candidate.elected ? <span class="sh-banner-counting">मतगणना जारी</span> : ""} */}
                                <span className="sh-winner data">
                                  <span>मत</span> {translateNumber(candidate.vote, lang)}
                                </span>
                              </div>
              </div>

              <div className="sh-profile-content">
                <div className="sh-profile-left">
                  <img
                    src={candidatePhotoSrc}
                    alt={candidate.name_en}
                    className="sh-profile-photo"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + candidateGender + ".jpg";
                    }}
                  />

                  <div className="sh-profile-name-block">
                    <h1>{candidate["name_" + lang]}</h1>
                    <div className="sh-profile-party-row">
                      <span className="sh-profile-party-logo">
                        <img
                          src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                          alt={candidate.party_code}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                          }}
                        />
                      </span>
                      <span className="sh-profile-party-name">{props.parties[candidatePartyCode] ? props.parties[candidatePartyCode][lang] : candidatePartyCode}</span>
                    </div>
                  </div>
                </div>

                <div className="sh-profile-right">
                  <div className="sh-profile-meta-list">
                    <div className="sh-profile-meta-item">
                      <span className="sh-profile-meta-label">{translate("age", lang)}</span>
                      <span className="sh-profile-meta-value">{translateNumber(candidate.age, lang) + " " + translate("year", lang)}</span>
                    </div>
                    <div className="sh-profile-meta-item">
                      <span className="sh-profile-meta-label">{translate("gender", lang)}</span>
                      <span className="sh-profile-meta-value">{candidate.gender === "M" ? translate("male", lang) : candidate.gender === "F" ? translate("female", lang) : translate("other", lang)}</span>
                    </div>
                    <div className="sh-profile-meta-item">
                      <span className="sh-profile-meta-label">{translate("region", lang)}</span>
                      <span className="sh-profile-meta-value">
                        {props.districtNames[candidate.district_id][lang]} - {translateNumber(candidate.region_id, lang)}
                      </span>
                    </div>
                    <div className="sh-profile-meta-item">
                      <span className="sh-profile-meta-label">{translate("candidancy", lang)}</span>
                      <span className="sh-profile-type-badge">{candidate.rtype === "federal" ? translate("parliament_member", lang) : translate("province_member", lang)}</span>
                    </div>
                  </div>

                  {candidate.descriptions ? (
                    <p className="sh-profile-description">
                      <span>{translate("background", lang)}</span>: {candidate.descriptions}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="sh-profile-sidebar">
            <div className="sh-profile-sidebar-card">
              <div className="sh-profile-sidebar-title">
                <h2>
                  {props.districtNames[candidate.district_id][lang] + " - " + translateNumber(candidate.region_id, lang)}: {translate("other", lang) + " " + translate("candidates", lang)}
                </h2>
              </div>
              <div className="sh-profile-sidebar-list">
                {props.data
                  .filter((c) => c.district_id === candidate.district_id && c.region_id === candidate.region_id && c.name_en !== candidate.name_en)
                  .sort((c, d) => d.vote - c.vote)
                  .map((c, i) => {
                    const party_code = c.party_code.match(/I+\d/) ? "I" : c.party_code;
                    let symbol = party_code.toUpperCase();
                    if (symbol === "I") {
                      symbol = getIndependentSymbol(c.district_id, c.region_id, c.name_en);
                    }
                    const gender = c.gender ? c.gender : "O";
                    const otherCandidatePhotoSrc =
                      c.candidatephoto && c.candidatephoto.trim() !== ""
                        ? c.candidatephoto
                        : `https://result.election.gov.np/Images/Candidate/${c.candidateid}.jpg`;

                    return (
                      <div className="sh-profile-other-item" key={i}>
                        <div className="sh-profile-other-info">
                          <img
                            src={otherCandidatePhotoSrc}
                            alt={c.name_en}
                            className="sh-profile-other-photo"
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
                            }}
                          />
                          <div className="sh-profile-other-text">
                            <Link to={"/candidates/profile/" + c.id + "?lang=" + lang}>{c["name_" + lang]}</Link>
                            <p>{props.parties[party_code] ? props.parties[party_code][lang] : party_code}</p>
                            <span className="sh-other-vote">
                              {translate("vote", lang)}: {translateNumber(c.vote, lang)} <span className="sh-elected-text-sidebar"> {c.elected  && translate("elected", lang)}</span>
                            </span>
                          </div>
                        </div>
                        <div className="sh-profile-other-party">
                          <img
                            src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                            alt={c.party_code.toLowerCase()}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Profile;
